<template>
    <div class="inline-block">
        <slot v-if="isEditing" name="edit" :stop-edit="stopEdit"/>
        <div v-else class="flex items-center">
            <slot
                name="static"
                class="cursor-pointer"
                :start-edit="startEdit"
                @click="startEdit"
            />
            <slot v-if="!isEditing" name="edit-button" :start-edit="startEdit">
                <UButton
                    class="ml-2"
                    size="sm"
                    variant="ghost"
                    cikir="neutral"
                    icon="i-ph-pencil"
                    title="Rediger"
                    tabindex="-1"
                    @click="startEdit"
                />
            </slot>
        </div>
    </div>
</template>

<script setup lang="ts">
import {ref} from 'vue'

const props = defineProps({
    defaultEditing: {
        type: Boolean,
        default: false
    }
})

const isEditing = ref(props.defaultEditing)
const startEdit = () => {
    isEditing.value = true
}
const stopEdit = () => {
    isEditing.value = false
}

</script>

<style scoped>

</style>